import { useTranslation } from "react-i18next";
import type { GuideTips } from "@ckgo2/shared/types";
import { GUIDE_TIP_KEYS, updateTip } from "./guideProfileModel";

/**
 * Tři tipy průvodce (oblíbené místo nebo zážitek, co ochutnat, rada před cestou), prostý text.
 * Prezentační komponenta: vazbu (`Controller`) a nápovědu drží stránka `GuideEditPage`.
 * Když žádné pole nemá text, hodnota je `null` (`updateTip`), ne `{}`.
 *
 * Háčky E2E: kořen `data-tipy`, pole `data-tip="<klíč>"`.
 */
interface Props {
  value: GuideTips | null | undefined;
  onChange: (tips: GuideTips | null) => void;
}

export default function GuideTipsFields({ value, onChange }: Props) {
  const { t } = useTranslation();
  const labels = {
    favoritePlace: t("guideProfile.tips.favoritePlace"),
    food: t("guideProfile.tips.food"),
    advice: t("guideProfile.tips.advice"),
  };
  const placeholders = {
    favoritePlace: t("guideProfile.tips.favoritePlacePlaceholder"),
    food: t("guideProfile.tips.foodPlaceholder"),
    advice: t("guideProfile.tips.advicePlaceholder"),
  };

  return (
    <div data-tipy="" className="space-y-4">
      {GUIDE_TIP_KEYS.map((key) => (
        <div key={key}>
          <label htmlFor={`guide-tip-${key}`} className="label">
            {labels[key]}
          </label>
          <textarea
            id={`guide-tip-${key}`}
            rows={3}
            className="input"
            value={value?.[key] ?? ""}
            onChange={(e) => onChange(updateTip(value ?? null, key, e.target.value))}
            placeholder={placeholders[key]}
            data-tip={key}
          />
        </div>
      ))}
    </div>
  );
}
